import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data.session_token) {
          localStorage.setItem("telesis_session_token", data.session_token);
        }
        setUser(data.user);
        window.history.replaceState({}, "", "/feed");
        navigate("/feed", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error("Auth callback failed", e);
        setError("Authentication failed. Try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1200);
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-200">
      <div className="telesis-panel px-8 py-6 rounded">
        <p className="telesis-eyebrow mb-2">Telesis</p>
        <p className="text-sm">{error || "Finalising session..."}</p>
      </div>
    </div>
  );
}
